/* ============================================================
   CARGO BUTLER — REDESIGNED JS
   ============================================================ */

/* ── 2-Step Checkout (global scope for inline onclick) ── */
var cbUpgradesTotal = 0;
var cbBasePrice = 49.99;

function cbGoStep(n) {
  for (var i = 1; i <= 3; i++) {
    var panel = document.getElementById('cb-step-' + i);
    var dot   = document.getElementById('step-dot-' + i);
    if (!panel || !dot) continue;
    if (i < n) {
      panel.style.display = 'none';
      dot.classList.remove('is-active');
      dot.classList.add('is-done');
    } else if (i === n) {
      panel.style.display = '';
      dot.classList.add('is-active');
      dot.classList.remove('is-done');
    } else {
      panel.style.display = 'none';
      dot.classList.remove('is-active', 'is-done');
    }
  }
  var offerEl = document.getElementById('offer');
  if (offerEl) offerEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  if (n === 3) cbUpdateOrderSummary();
}

function cbToggleUpgrade(btn, kit, price) {
  var card = btn.closest('.cb-upgrade-card');
  if (card.classList.contains('is-added')) {
    card.classList.remove('is-added');
    btn.textContent = 'Add to Order';
    cbUpgradesTotal -= price;
  } else {
    card.classList.add('is-added');
    btn.textContent = '\u2713 Added';
    cbUpgradesTotal += price;
  }
  var totalEl = document.getElementById('cb-total-display');
  if (totalEl) totalEl.textContent = '$' + (cbBasePrice + cbUpgradesTotal).toFixed(2);
}

function cbUpdateOrderSummary() {
  // Detect selected plan
  var activeTile = document.querySelector('.cb-plan-tile.is-active');
  var isMulti = activeTile ? activeTile.getAttribute('data-plan') === 'multi' : true;

  // Base prices
  var fullBase   = isMulti ? 199.96 : 179.96;  // full order total for main set
  var todayBase  = isMulti ? 49.99  : 179.96;  // charged today for main set
  var installAmt = 49.99;                       // per-installment amount

  var fullTotal  = fullBase  + cbUpgradesTotal;
  var todayTotal = todayBase + cbUpgradesTotal;

  // Main set row
  var mainEl = document.getElementById('os-main-price');
  if (mainEl) mainEl.textContent = isMulti ? '4 × $49.99' : '$179.96';

  // Upgrades row
  var upgradesRow = document.getElementById('os-upgrades');
  var upgradesEl  = document.getElementById('os-upgrades-price');
  if (cbUpgradesTotal > 0) {
    if (upgradesRow) upgradesRow.style.display = '';
    if (upgradesEl)  upgradesEl.textContent = '+$' + cbUpgradesTotal.toFixed(2);
  } else {
    if (upgradesRow) upgradesRow.style.display = 'none';
  }

  // Today charge row
  var todayEl = document.getElementById('os-today');
  if (todayEl) todayEl.textContent = '$' + todayTotal.toFixed(2);

  // Full order total row
  var totalEl = document.getElementById('os-total');
  if (totalEl) totalEl.textContent = '$' + fullTotal.toFixed(2);

  // Installment note (only for multi-pay)
  var noteEl = document.getElementById('os-installment-note');
  var amtEl  = document.getElementById('os-installment-amt');
  if (noteEl) noteEl.style.display = isMulti ? '' : 'none';
  if (amtEl)  amtEl.textContent = '$' + installAmt.toFixed(2);
}

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ── FAQ Accordion ── */
  function initFaq() {
    document.querySelectorAll('.cb-faq-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.cb-faq-item');
        const isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.cb-faq-item.is-open').forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Plan Switcher ── */
  function initPlanSwitcher() {
    const tiles = document.querySelectorAll('.cb-plan-tile');
    tiles.forEach(tile => {
      tile.addEventListener('click', () => {
        tiles.forEach(t => t.classList.remove('is-active'));
        tile.classList.add('is-active');
        const plan = tile.dataset.plan;
        // Update global base price for checkout summary
        cbBasePrice = plan === 'single' ? 179.96 : 49.99;
        document.querySelectorAll('[data-plan-show]').forEach(el => {
          el.style.display = el.dataset.planShow === plan ? '' : 'none';
        });
        // Update running total display
        var totalEl = document.getElementById('cb-total-display');
        if (totalEl) totalEl.textContent = '$' + (cbBasePrice + cbUpgradesTotal).toFixed(2);
      });
    });
  }

  /* ── Carousel ── */
  function initCarousel(el) {
    const slides = el.querySelectorAll('.cb-slide');
    const dots = el.querySelectorAll('.cb-carousel__dot');
    const bar = el.querySelector('.cb-carousel__progress-bar');
    const prevBtn = el.querySelector('.cb-carousel__arrow--prev');
    const nextBtn = el.querySelector('.cb-carousel__arrow--next');
    let current = 0;
    let timer = null;
    const interval = parseInt(el.dataset.interval) || 5000;

    function show(idx) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      if (bar) { bar.style.width = '0%'; requestAnimationFrame(() => { bar.style.transition = `width ${interval}ms linear`; bar.style.width = '100%'; }); }
    }

    function autoplay() { timer = setInterval(() => show(current + 1), interval); }
    function stopAutoplay() { clearInterval(timer); }

    show(0);
    autoplay();
    el.addEventListener('mouseenter', stopAutoplay);
    el.addEventListener('mouseleave', autoplay);
    if (prevBtn) prevBtn.addEventListener('click', () => { stopAutoplay(); show(current - 1); autoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { stopAutoplay(); show(current + 1); autoplay(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { stopAutoplay(); show(i); autoplay(); }));

    // Touch/swipe
    let startX = 0;
    el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { stopAutoplay(); show(dx < 0 ? current + 1 : current - 1); autoplay(); }
    });
  }

  /* ── Unified Slider (cb-uslider) ── */
  function initUSlider(slider) {
    if (!slider) return;
    const track = slider.querySelector('.cb-uslider__track');
    const slides = track.querySelectorAll('.cb-uslide');
    const dotsContainer = slider.querySelector('.cb-uslider__dots');
    const prevBtn = slider.querySelector('.cb-uslider__arrow--prev');
    const nextBtn = slider.querySelector('.cb-uslider__arrow--next');
    const interval = parseInt(slider.dataset.interval) || 2000;
    const total = slides.length;
    let current = 0;
    let timer = null;

    // Build dots
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'cb-uslider__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', () => { stop(); go(i); start(); });
      dotsContainer.appendChild(dot);
    });

    function getDots() { return dotsContainer.querySelectorAll('.cb-uslider__dot'); }

    function getSlideWidth() {
      // On mobile (padding-right:0), each slide is 100% wide
      return slider.offsetWidth;
    }

    function go(idx) {
      current = (idx + total) % total;
      const sw = getSlideWidth();
      track.style.transform = 'translateX(-' + (current * sw) + 'px)';
      getDots().forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    function start() { timer = setInterval(() => go(current + 1), interval); }
    function stop() { clearInterval(timer); }

    start();
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    if (prevBtn) prevBtn.addEventListener('click', () => { stop(); go(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { stop(); go(current + 1); start(); });

    // Touch / drag swipe
    let startX = 0, isDragging = false;
    slider.addEventListener('mousedown', e => { startX = e.clientX; isDragging = true; stop(); });
    slider.addEventListener('mousemove', e => { if (isDragging) e.preventDefault(); });
    slider.addEventListener('mouseup', e => {
      if (!isDragging) return;
      isDragging = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? current + 1 : current - 1);
      start();
    });
    slider.addEventListener('mouseleave', () => { if (isDragging) { isDragging = false; start(); } });
    slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; stop(); }, { passive: true });
    slider.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? current + 1 : current - 1);
      start();
    });

    window.addEventListener('resize', () => go(current), { passive: true });
  }

  function initChaosSlider() {
    // Legacy alias — now handled by initUSlider
  }

  /* ── Kit Flip (hover to reveal cargo image) ── */
  function initKitFlip() {
    document.querySelectorAll('.cb-kit-flip').forEach(function(pane) {
      pane.addEventListener('mouseenter', function() { pane.classList.add('is-flipped'); });
      pane.addEventListener('mouseleave', function() { pane.classList.remove('is-flipped'); });
      pane.addEventListener('touchstart', function() { pane.classList.toggle('is-flipped'); }, { passive: true });
    });
  }

  /* ── Sticky Bar ── */
  function initSticky() {
    const bar = document.querySelector('.cb-sticky');
    if (!bar) return;
    let shown = false;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500 && !shown) { bar.classList.add('is-visible'); shown = true; }
      else if (window.scrollY < 200 && shown) { bar.classList.remove('is-visible'); shown = false; }
    }, { passive: true });
  }

  /* ── Mute Toggle ── */
  function initMute() {
    document.querySelectorAll('.cb-mute-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const isMuted = btn.dataset.muted === 'true';
        const iframe = document.getElementById(btn.dataset.target);
        if (iframe) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: isMuted ? 'unMute' : 'mute',
            args: []
          }), '*');
        }
        btn.dataset.muted = isMuted ? 'false' : 'true';
      });
    });
  }

  ready(() => {
    initFaq();
    initPlanSwitcher();
    document.querySelectorAll('.cb-carousel').forEach(initCarousel);
    document.querySelectorAll('.cb-uslider').forEach(initUSlider);
    initKitFlip();
    initSticky();
    initMute();
  });
})();


/* ============================================================
   IMPLEMENTATION PACKAGE ADD-ONS  (tiers · upsell modal · wizard)
   ============================================================ */
/* ==== IMPLEMENTATION PACKAGE ADD-ONS ==== */

/* ---- Tier select -> open upsell modal ---- */
function cbSelectTier(name, multi, single){
  var t = document.getElementById('cb-upsell-tier'); if(t) t.textContent = name;
  var ct = document.getElementById('cb-confirm-tier'); if(ct) ct.textContent = name;
  var p = document.getElementById('cb-upsell-price'); if(p) p.textContent = multi + '  (or ' + single + ' one-time)';
  var main = document.getElementById('cb-upsell-main'); if(main) main.style.display = '';
  var conf = document.getElementById('cb-upsell-confirm'); if(conf) conf.hidden = true;
  var m = document.getElementById('cb-upsell');
  if(m){ m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); }
  document.body.style.overflow = 'hidden';
}
function cbCloseUpsell(){
  var m = document.getElementById('cb-upsell');
  if(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); }
  document.body.style.overflow = '';
}
function cbToggleAddon(btn){
  btn.classList.toggle('is-added');
  btn.textContent = btn.classList.contains('is-added') ? 'Added ✓' : (btn.dataset.label || 'Add');
}
function cbCheckout(){
  var main = document.getElementById('cb-upsell-main'); if(main) main.style.display = 'none';
  var conf = document.getElementById('cb-upsell-confirm'); if(conf) conf.hidden = false;
}

/* ---- Build-Your-Cargo-Butler wizard ---- */
function cbWizState(){ window.__cbWiz = window.__cbWiz || { step:1, ans:{} }; return window.__cbWiz; }
function cbWizShow(step){
  var s = cbWizState(); s.step = step;
  document.querySelectorAll('.cb-wiz-step').forEach(function(el){
    el.classList.toggle('is-active', el.dataset.step === String(step));
  });
  var bar  = document.getElementById('cb-wiz-bar');
  var back = document.getElementById('cb-wiz-back');
  if(step === 'result'){
    if(bar) bar.style.width = '100%';
    if(back) back.hidden = true;
  } else {
    if(bar) bar.style.width = (step * 33) + '%';
    if(back) back.hidden = (step === 1);
  }
}
function cbWizPick(btn, key, val){
  var s = cbWizState(); s.ans[key] = val;
  var opts = btn.parentNode.querySelectorAll('.cb-wiz-opt');
  opts.forEach(function(o){ o.classList.remove('is-picked'); });
  btn.classList.add('is-picked');
  setTimeout(function(){
    if(key === 'vehicle') cbWizShow(2);
    else if(key === 'size') cbWizShow(3);
    else cbWizResult();
  }, 180);
}
function cbWizBack(){
  var s = cbWizState();
  if(typeof s.step === 'number' && s.step > 1) cbWizShow(s.step - 1);
}
function cbWizRestart(){
  var s = cbWizState(); s.ans = {};
  document.querySelectorAll('.cb-wiz-opt.is-picked').forEach(function(o){ o.classList.remove('is-picked'); });
  cbWizShow(1);
}
function cbWizResult(){
  var a = cbWizState().ans, tier, why, id;
  if(a.use === 'two'){ tier='2-Truck Family'; id='tier-family'; why='Two complete kits so both trucks are covered from day one.'; }
  else if(a.use === 'tools' || a.size === 'long'){ tier='Heavy Hauler'; id='tier-heavy'; why='Maximum coverage plus a Lifetime Warranty for daily job-site abuse.'; }
  else if(a.size === 'short' && (a.use === 'everyday' || a.vehicle !== 'truck')){ tier='Essentials'; id='tier-essentials'; why='Right-sized coverage for lighter, weekend loads.'; }
  else { tier='Standard'; id='tier-standard'; why='The everyday do-it-all kit — our most popular setup.'; }
  var n = document.getElementById('cb-wiz-name'); if(n) n.textContent = tier;
  var w = document.getElementById('cb-wiz-why'); if(w) w.textContent = why;
  var go = document.getElementById('cb-wiz-go'); if(go) go.onclick = function(){ cbHighlightTier(id); };
  cbWizShow('result');
}
function cbHighlightTier(id){
  var offer = document.getElementById('offer');
  if(offer) offer.scrollIntoView({ behavior:'smooth', block:'start' });
  var el = document.getElementById(id);
  if(el){
    document.querySelectorAll('.cb-tier.is-highlight').forEach(function(t){ t.classList.remove('is-highlight'); });
    setTimeout(function(){ el.classList.add('is-highlight'); }, 500);
    setTimeout(function(){ el.classList.remove('is-highlight'); }, 3200);
  }
}

/* ESC closes the upsell modal */
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape') cbCloseUpsell();
});


/* ==== VISUAL REVAMP (pass5) ==== */
/* Tap-to-flip for benefit cards on touch devices (hover handles desktop) */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.cb-benefit--flip').forEach(function(card){
    card.addEventListener('click', function(){ card.classList.toggle('is-flipped'); });
    card.addEventListener('keydown', function(e){
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); card.classList.toggle('is-flipped'); }
    });
  });
});


/* ==== PASS9 ==== */
function cbProceedCheckout(){ var n=document.getElementById('cb-checkout-note'); if(n) n.style.display='block'; }


/* ==== MOBILE BATCH (pass13) ==== */
function cbOpenVideo(){
  var m=document.getElementById('cb-video-modal'), f=document.getElementById('cb-modal-vid');
  if(f) f.src='https://www.youtube.com/embed/e5818g-aSFs?autoplay=1&rel=0&modestbranding=1&playsinline=1';
  if(m){ m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); }
  document.body.style.overflow='hidden';
}
function cbCloseVideo(){
  var m=document.getElementById('cb-video-modal'), f=document.getElementById('cb-modal-vid');
  if(f) f.src='';
  if(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); }
  document.body.style.overflow='';
}
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.cb-steps-hover .cb-two-step-card').forEach(function(card){
    var t=card.querySelector('.cb-two-step-card__title');
    if(t) t.addEventListener('click', function(){ card.classList.toggle('is-open'); });
  });
});
document.addEventListener('keydown', function(e){ if(e.key==='Escape') cbCloseVideo(); });


/* ==== PASS14: rotating hero headline ==== */
(function(){
  function start(){
    var el=document.getElementById('cb-hero-rotate'); if(!el) return;
    var phrases=(el.getAttribute('data-cb-rotate')||'').split('|').map(function(s){return s.trim();}).filter(Boolean);
    if(phrases.length<2) return;
    var i=0;
    setInterval(function(){
      el.style.opacity='0';
      setTimeout(function(){ i=(i+1)%phrases.length; el.textContent=phrases[i]; el.style.opacity='1'; }, 350);
    }, 2000);
  }
  if(document.readyState!=='loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();


/* ==== PASS16: mobile hamburger menu ==== */
function cbToggleMenu(){ var h=document.querySelector('.cb-header'); if(h) h.classList.toggle('is-menu-open'); }
function cbCloseMenu(){ var h=document.querySelector('.cb-header'); if(h) h.classList.remove('is-menu-open'); }
